interface ResourceScheduleConflictLike {
  id: string;
}

interface ResourceScheduleConflictGroup<TConflict extends ResourceScheduleConflictLike> {
  conflicts: TConflict[];
}

export function dedupeResourceScheduleConflicts<TConflict extends ResourceScheduleConflictLike>(
  conflictGroups: ReadonlyArray<ResourceScheduleConflictGroup<TConflict>>,
): TConflict[] {
  const seen = new Set<string>();

  return conflictGroups
    .flatMap((group) => group.conflicts)
    .filter((conflict) => {
      if (seen.has(conflict.id)) {
        return false;
      }

      seen.add(conflict.id);
      return true;
    });
}